import { render, staticRenderFns } from "./AddParts.vue?vue&type=template&id=9d204f1e&scoped=true&"
import script from "./AddParts.vue?vue&type=script&lang=js&"
export * from "./AddParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d204f1e",
  null
  
)

export default component.exports